import { getSale } from "./getSale";
import { getTaxRate } from "./getTaxRate";

export const calculateTotals = (
	cartItems,
	country,
	shipping = 0,
	promo = 0,
	state = null
) => {
	// Calculate retail price (MSRP)
	const msrp = cartItems.reduce(
		(total, item) =>
			total + item.optionInfo.RETAIL_PRICE * item.optionInfo.quantity,
		0
	);

	const numOfMotorItems = cartItems?.reduce(
		(total, item) =>
			total +
			(item.productInfo.Operation === "Motor" ? item.optionInfo.quantity : 0),
		0
	);

	const adjustedMsrp = country === "USA" ? msrp * 0.75 : msrp;

	// Calculate discount

	const discount = cartItems?.[0]?.productInfo?.Global_Discount;
	const secondaryDiscount = cartItems?.[0]?.productInfo?.Discount || 0;
	const adjustedDiscount =
		country === "USA" ? secondaryDiscount * 0.75 : secondaryDiscount;

	// Calculate per-item prices with discount
	const itemsWithPrices = cartItems.map((item) => {
		const itemMsrp = item.optionInfo.RETAIL_PRICE * item.optionInfo.quantity;
		const adjustedItemMsrp = country === "USA" ? itemMsrp * 0.75 : itemMsrp;
		const discountAmount = adjustedItemMsrp * discount;
		const finalPrice = adjustedItemMsrp - discountAmount;
		const secondDiscount = finalPrice * item.productInfo.Discount;
		const secondDiscountFinalprice = finalPrice - secondDiscount;

		return {
			...item,
			productInfo: {
				...item.productInfo,
				Global_Discount: discount,
				Discount: item.productInfo.Discount,
			},
			optionInfo: {
				...item.optionInfo,
				OUR_PRICE: secondDiscountFinalprice,
				RETAIL_PRICE: adjustedItemMsrp,
			},
		};
	});

	// Calculate our price using the discounted items
	const ourPrice = itemsWithPrices.reduce(
		(total, item) => total + item.optionInfo.OUR_PRICE,
		0
	);

	//45 - after 50% off price
	const chargerDiscountBase = cartItems.reduce(
		(total, item) =>
			total +
			(item.productInfo.charger === "Yes"
				? 45 * (1 - adjustedDiscount || 1)
				: 0),
		0
	);

	//93.75 - after 50% off price
	const remoteDiscountBase = cartItems.reduce(
		(total, item) =>
			total +
			(item.productInfo.remote === "Yes"
				? 93.75 * (1 - adjustedDiscount || 1)
				: 0),
		0
	);

	//138.75 - after 50% off price
	const connectorDiscountBase = cartItems.reduce(
		(total, item) =>
			total +
			(item.productInfo.connector === "Yes"
				? 168.75 * (1 - adjustedDiscount || 1)
				: 0),
		0
	);
	const discounts = [discount];

	const savings = discount ? adjustedMsrp - ourPrice : 0;
	const operationDiscount =
		msrp - savings > 1000 && numOfMotorItems > 1
			? 371.25 * (1 - adjustedDiscount)
			: 0;

	const baseSum =
		chargerDiscountBase + remoteDiscountBase + connectorDiscountBase;

	const motorAccDiscount = baseSum * 0.2;

	const taxRate = getTaxRate(state);
	const tax = !state
		? 0
		: taxRate *
		  (ourPrice - promo + shipping - operationDiscount - motorAccDiscount);

	console.log(
		"PRICE",
		ourPrice,
		promo,
		tax,
		shipping,
		itemsWithPrices,
		operationDiscount,
		motorAccDiscount
	);
	return {
		country: country,
		msrp: adjustedMsrp,
		ourPrice: ourPrice,
		tax: !tax ? 0 : tax.toFixed(2),
		shipping: shipping,
		subTotal:
			ourPrice - promo + tax + shipping - operationDiscount - motorAccDiscount,
		savings,
		discount: discount,
		discounts: discounts,
		taxRate: taxRate,
		items: itemsWithPrices,
		operationDiscount: operationDiscount,
		motorAccDiscount: motorAccDiscount, // Added items with their individual
		// prices
		//  and discounts
		displayMsrp: `$${adjustedMsrp.toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
		displayOurPrice: `$${(
			ourPrice -
			operationDiscount -
			motorAccDiscount
		).toFixed(2)} ${country === "USA" ? "USD" : "CAD"}`,
		displaySavings: `$${savings.toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
		displayOperationSavings: `$${operationDiscount.toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
		displaymotorAccDiscount: `$${motorAccDiscount.toFixed(2)} ${
			country === "USA" ? "USD" : "CAD"
		}`,
	};
};
